
import DaisoImage from '~/components/common/DaisoImage.vue'

export default {
  name: 'PageTitleArea',
  components: {
    DaisoImage
  },
  props: {
    align: {
      type: String,
      default: 'left',
    },
    fullBgImage: {
      type: String,
      default: null,
    },
    fullBgColor: {
      type: String,
      default: null
    },
    ratePageImage: {
      type: String,
      default: null
    },
    altText: {
      type: String,
      default: '배경 이미지'
    }
  },
}
